import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';

// idb store name
const storeName = 'saidas';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configColetor');
const host = configLocal ? JSON.parse(configLocal).host : '';
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const sqlSaida = configLocal ? JSON.parse(configLocal).sqlSaida : '';
const sqlItemSaida = configLocal ? JSON.parse(configLocal).sqlItemSaida : '';

export const pedidoService = {
  getPedidos,
  getPedidosAPI,
  getPedido,
  addPedido,
  updatePedido,
  sendPedidos,
};

async function getPedidos() {
  // Fetch indexedDB Items
  const itemsIndexedDB = await getIndexedDBPedidos();
  if (itemsIndexedDB.length) return itemsIndexedDB;
  return getPedidosAPI();
}

async function sendPedidos(pedidos) {
  // Envia as produções via POST
  if (pedidos && pedidos.length) {
    for (const pedido of pedidos) {
      const res = await apiRequest.post(`${baseURL}/saida`, {
        opcoes: {
          acao: "ImportaQtdeItemCsv",
          id_usuario: 1,
          id_empresa: pedido.id_empresa,
          id_saida: pedido.id_saida
        },
        dados: pedido
      });
      console.log(res);
    }
  }
}

async function getPedidosAPI() {
  const response = await apiRequest.get(`${baseURL}/sql/${sqlSaida}`);
  const pedidosApi = environment === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
  // Add items to indexedDB
  if (pedidosApi && pedidosApi.length) {
    for (const pedido of pedidosApi) {
      const res = await getPedidoItensAPI(pedido.id_saida);
      const itens = res.data.Sql;
      pedido.itens = itens && itens.length ? itens : [];
      pedido.qtde_realizada = 0;
      if (pedido.itens.length) {
        pedido.itens.forEach(item => {
          item.barras = [];
          item.qtde_prevista = Number(item.qtde_prevista);
          item.qtde_realizada = 0;
        });
      }
      pedido.qtde_prevista = pedido.itens.reduce((acc, cur) => cur.qtde_prevista + acc, 0);
    }
  }
  await compareAndUpdatePedidos(pedidosApi);
  await removeInexistentes(pedidosApi);
  return pedidosApi;
}

function getPedidoItensAPI(idPedido) {
  return apiRequest.get(`${baseURL}/sql/${sqlItemSaida}?:idPedido=${idPedido}`);
}

function getIndexedDBPedidos() {
  return idbService.getAll(storeName);
}

function getPedido(id) {
  return idbService.getById(storeName, id);
}

async function compareAndUpdatePedidos(pedidos) {
  if (pedidos && pedidos.length) {
    for (const pedido of pedidos) {
      const savedPedido = await getPedido(pedido.id_saida);
  
      if (!savedPedido) {
        pedido.versao_imp = 1;
        await addPedido(pedido);
      } else if (pedido.itens && pedido.itens.length) {
        pedido.itens.forEach(item => {
          // Busca os barras salvos se existir, caso não retorna array vazio
          const savedPedidoItem = savedPedido.itens.find(svdPedidoItem => svdPedidoItem.id_produto == item.id_produto);
          item.barras = savedPedidoItem ? savedPedidoItem.barras : [];
          // Atualiza a qtde_realizada com base nas barras
          item.qtde_realizada = sumQtdeRealizadaItem(item);
        });
        pedido.versao_imp = savedPedido.versao_imp ? savedPedido.versao_imp + 1 : 1;
        await updatePedido(pedido);
      } else {
        pedido.versao_imp = savedPedido.versao_imp ? savedPedido.versao_imp + 1 : 1;
        await updatePedido(pedido);
      }
    }
  } else {
    // Limpa os registros do store pedidos
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(pedidosApi) {
  if (pedidosApi && pedidosApi.length) {
    const idsPedidosApi = pedidosApi.map(pedidoApi => pedidoApi.id_saida);
    const pedidosLocal = await idbService.getAll(storeName);
    const pedidosInexistentes = pedidosLocal.filter(pedidoLocal => !idsPedidosApi.includes(pedidoLocal.id_saida));
    if (pedidosInexistentes && pedidosInexistentes.length) {
      for (const pedido of pedidosInexistentes) {
        await idbService.deleteFromStore(storeName, pedido.id_saida);
      }
    }
  } else {
    return;
  }
}

async function addPedido(pedido) {
  return idbService.addToStore(storeName, pedido);
}

async function updatePedido(pedido) {
  if (pedido.itens && pedido.itens.length) {
    pedido.itens.forEach(item => sumQtdeRealizadaItem(item));
    pedido.qtde_realizada = sumQtdeRealizadaPedido(pedido.itens);
  }
  await idbService.updateItem(storeName, pedido);
}

function sumQtdeRealizadaItem(item) {
  return item.qtde_realizada = item.barras.reduce((acc, cur) => acc += cur.qtde, 0);
}

function sumQtdeRealizadaPedido(itens) {
  let totalRealizado = 0;
  itens.forEach(item => totalRealizado += item.barras.reduce((acc, cur) => acc += cur.qtde, 0));
  return totalRealizado
}